import React, { useEffect, useState } from 'react';
import { Menu, X, Flower2 } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Schedule',
    href: '#schedule'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="flex justify-between items-center" data-id="element-273">
          {/* Logo */}
          <a href="#home" onClick={e => handleNavClick(e, '#home')} className="flex items-center gap-2 group" data-id="element-274">
            <Flower2 className={`w-8 h-8 transition-colors ${isScrolled ? 'text-yoga-primary' : 'text-white group-hover:text-yoga-primary'}`} data-id="element-275" />
            <span className={`text-xl font-bold tracking-wide transition-colors ${isScrolled ? 'text-yoga-dark' : 'text-white'}`} data-id="element-276">
              Shree Yoga Fitness
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-277">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className={`text-sm font-medium transition-colors hover:text-yoga-primary ${isScrolled ? 'text-yoga-muted' : 'text-white/90'}`} data-id="element-278">
                {link.name}
              </a>)}
            <a href="#contact" onClick={e => handleNavClick(e, '#contact')} className="bg-yoga-primary text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-yoga-light transition-colors shadow-sm hover:shadow-md" data-id="element-279">
              Book a class
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-280">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md focus:outline-none ${isScrolled ? 'text-yoga-dark' : 'text-white'}`} aria-label="Toggle menu" data-id="element-281">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-282" /> : <Menu className="w-6 h-6" data-id="element-283" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <div className={`md:hidden fixed inset-0 bg-white z-40 transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
      top: '60px'
    }} data-id="element-284">
        <div className="flex flex-col px-6 py-8 space-y-6 bg-white h-full overflow-y-auto" data-id="element-285">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-xl font-medium text-yoga-dark hover:text-yoga-primary transition-colors" data-id="element-286">
              {link.name}
            </a>)}
          <div className="pt-6 border-t border-gray-100" data-id="element-287">
            <a href="#contact" onClick={e => handleNavClick(e, '#contact')} className="block w-full text-center bg-yoga-primary text-white px-6 py-3 rounded-full text-lg font-bold hover:bg-yoga-light transition-colors" data-id="element-288">
              Book a class
            </a>
          </div>
        </div>
      </div>
    </nav>;
}